export default {
  'base.adminUser.title': '用户管理',
  'base.adminUser.colId': 'ID',
  'base.adminUser.colUsername': '用户名',
  'base.adminUser.colAvatar': '头像',
  'base.adminUser.colEmail': '邮箱',
  'base.adminUser.colRole': '角色',
  'base.adminUser.colStatus': '状态',
  'base.adminUser.colCreatedAt': '创建时间',
  'base.adminUser.colCredit': '点数',
  'base.adminUser.adjustCredit': '调整点数',
  'base.adminUser.colAction': '操作',
  'base.adminUser.searchPlaceholder': '搜索用户名 / 邮箱',
  'base.adminUser.empty': '暂无用户',
  'base.adminUser.total': '共 {total} 条',
  'base.adminUser.deleteSuccess': '删除成功',
  'base.adminUser.deleteFailed': '删除失败',
  'base.adminUser.roleAdmin': '管理员',
  'base.adminUser.roleUser': '用户',
  'base.adminUser.statusNormal': '正常',
  'base.adminUser.statusDisabled': '已禁用',
  'base.adminUser.confirmDelete': '确定要删除该用户吗？',

  'base.adminUserModal.titleEdit': '修改用户',
  'base.adminUserModal.titleAdd': '新增用户',
  'base.adminUserModal.avatarLabel': '头像',
  'base.adminUserModal.avatarUpload': '上传',
  'base.adminUserModal.avatarReset': '恢复默认',
  'base.adminUserModal.avatarResetTitle': '恢复默认头像',
  'base.adminUserModal.avatarResetDesc': '将移除当前头像并恢复为默认头像，确定继续吗？',
  'base.adminUserModal.avatarUploadSuccess': '头像上传成功',
  'base.adminUserModal.avatarUploadFailed': '头像上传失败',
  'base.adminUserModal.usernameLabel': '用户名',
  'base.adminUserModal.usernamePlaceholder': '请输入用户名',
  'base.adminUserModal.usernameRequired': '请输入用户名',
  'base.adminUserModal.passwordLabelEdit': '密码（留空则不修改）',
  'base.adminUserModal.passwordLabel': '密码',
  'base.adminUserModal.passwordPlaceholder': '至少 6 个字符',
  'base.adminUserModal.passwordMin': '密码至少 6 个字符',
  'base.adminUserModal.emailLabel': '邮箱',
  'base.adminUserModal.emailPlaceholder': '选填，用于找回密码',
  'base.adminUserModal.roleLabel': '角色',
  'base.adminUserModal.roleUser': '普通用户',
  'base.adminUserModal.roleAdmin': '管理员',
  'base.adminUserModal.statusLabel': '状态',
  'base.adminUserModal.saveSuccess': '保存成功',
  'base.adminUserModal.saveFailed': '保存失败',

  'base.adminRegister.title': '注册登录',
  'base.adminRegister.sectionTitle': '注册设置',
  'base.adminRegister.enableLabel': '开启注册',
  'base.adminRegister.enableDesc':
    '开启后，登录页将出现「注册」入口，允许访客自助注册普通用户账号。',
  'base.adminRegister.requireEmailLabel': '注册需填写邮箱',
  'base.adminRegister.requireEmailDesc':
    '开启后，注册时必须填写邮箱，并通过邮箱验证码校验。需先完成邮件设置。默认关闭。',
  'base.adminRegister.requirePhoneLabel': '注册需填写手机号',
  'base.adminRegister.requirePhoneDesc':
    '开启后，注册时必须填写手机号，并通过短信验证码校验。需先完成短信设置。默认关闭。',
  'base.adminRegister.needEmailCodeSmtpHint':
    '尚未配置 SMTP，请先在「设置 - 邮件设置」中完成配置后再开启。',
  'base.adminRegister.needPhoneSmsHint':
    '尚未配置短信服务，请先在「设置 - 短信设置」中完成配置后再开启。',
  'base.adminRegister.saved': '已保存',
  'base.adminRegister.saveFailed': '保存失败',

  'base.adminAgreement.userTitle': '用户协议',
  'base.adminAgreement.privacyTitle': '隐私协议',
  'base.adminAgreement.userPlaceholder': '请输入用户协议内容（Markdown）',
  'base.adminAgreement.privacyPlaceholder': '请输入隐私协议内容（Markdown）',
  'base.adminAgreement.insertExample': '插入示例',
  'base.adminAgreement.exampleConfirmTitle': '插入示例文档',
  'base.adminAgreement.exampleConfirmDesc': '当前编辑器已有内容，插入示例将覆盖现有内容，是否继续？',
  'base.adminAgreement.exampleOverwrite': '覆盖',
  'base.adminAgreement.exampleInserted': '示例文档已插入',
  'base.adminAgreement.saved': '已保存',
  'base.adminAgreement.saveFailed': '保存失败',

  'base.adminPay.title': '支付设置',
  'base.adminPay.alipay': '支付宝',
  'base.adminPay.wechat': '微信支付',
  'base.adminPay.connect': '魔众 Connect 聚合支付',
  'base.adminPay.appId': 'AppId',
  'base.adminPay.privateKey': '应用私钥（RSA2）',
  'base.adminPay.alipayPublicKey': '支付宝公钥',
  'base.adminPay.mchId': '商户号 MchId',
  'base.adminPay.apiKey': 'API 密钥',
  'base.adminPay.serverUrl': '服务地址',
  'base.adminPay.serverUrlPlaceholder': 'https://connect.tecmz.com',
  'base.adminPay.connectTest': '测试连通性',
  'base.adminPay.connectTestSuccess': '连接成功',
  'base.adminPay.connectTestFailed': '连接失败',
  'base.adminPay.connectAppId': 'AppId',
  'base.adminPay.appSecret': 'AppSecret',
  'base.adminPay.connectCallbackHint': '支付回调地址将使用「设置 - 基本设置」中的网站访问 URL，请确保其为外部可访问地址',
  'base.adminPay.saved': '已保存',
  'base.adminPay.saveFailed': '保存失败',
  'base.adminPay.rechargeAgreementTitle': '充值服务协议',
  'base.adminPay.rechargeAgreementPlaceholder': '请输入充值服务协议内容（Markdown），配置后展示在用户充值界面',

  'base.adminPackage.title': '点数套餐',
  'base.adminPackage.addTitle': '新增套餐',
  'base.adminPackage.editTitle': '修改套餐',
  'base.adminPackage.colId': 'ID',
  'base.adminPackage.colTitle': '标题',
  'base.adminPackage.colMarketPrice': '市场价格（元）',
  'base.adminPackage.colPayPrice': '付款价格（元）',
  'base.adminPackage.colCredit': '点数',
  'base.adminPackage.colBonus': '赠送点数',
  'base.adminPackage.colSort': '排序',
  'base.adminPackage.colEnable': '状态',
  'base.adminPackage.colDescription': '说明',
  'base.adminPackage.colAction': '操作',
  'base.adminPackage.enabled': '启用',
  'base.adminPackage.disabled': '下架',
  'base.adminPackage.empty': '暂无套餐',
  'base.adminPackage.titlePlaceholder': '如：标准包',
  'base.adminPackage.titleRequired': '请输入套餐标题',
  'base.adminPackage.confirmDelete': '确定要删除该套餐吗？',
  'base.adminPackage.deleteSuccess': '删除成功',
  'base.adminPackage.deleteFailed': '删除失败',
  'base.adminPackage.saveSuccess': '保存成功',
  'base.adminPackage.saveFailed': '保存失败',

  'base.adminOrder.title': '点数购买记录',
  'base.adminOrder.colOrderNo': '订单号',
  'base.adminOrder.colUser': '用户',
  'base.adminOrder.colTitle': '套餐',
  'base.adminOrder.colPrice': '金额',
  'base.adminOrder.colRefundAmount': '已退金额',
  'base.adminOrder.colCredit': '点数',
  'base.adminOrder.colPayType': '支付方式',
  'base.adminOrder.colStatus': '状态',
  'base.adminOrder.colCreatedAt': '时间',
  'base.adminOrder.colAction': '操作',
  'base.adminOrder.statusAll': '全部状态',
  'base.adminOrder.statusNew': '待支付',
  'base.adminOrder.statusPayed': '已支付',
  'base.adminOrder.statusClosed': '已关闭',
  'base.adminOrder.statusRefunded': '已退款',
  'base.adminOrder.statusPartRefunded': '部分退款',
  'base.adminOrder.refund': '退款',
  'base.adminOrder.searchPlaceholder': '搜索订单号 / 用户',
  'base.adminOrder.empty': '暂无订单',
  'base.adminOrder.actionFailed': '操作失败',

  'base.adminOrderRefund.title': '订单退款',
  'base.adminOrderRefund.orderPrice': '订单金额',
  'base.adminOrderRefund.refunded': '已退金额',
  'base.adminOrderRefund.refundable': '可退金额',
  'base.adminOrderRefund.amount': '退款金额',
  'base.adminOrderRefund.fillFull': '全额退款',
  'base.adminOrderRefund.remark': '退款备注',
  'base.adminOrderRefund.remarkPlaceholder': '如：用户申请部分退款',
  'base.adminOrderRefund.notice': '系统只记录退款状态与金额，不会自动扣减用户点数，也不代发起渠道退款；请到支付宝 / 微信商户后台按该金额完成退款。如需扣点，',
  'base.adminOrderRefund.adjustCredit': '去调整点数',
  'base.adminOrderRefund.tradeNo': '渠道退款单号',
  'base.adminOrderRefund.tradeNoPlaceholder': '在渠道后台退款后回填',
  'base.adminOrderRefund.tradeNoHint': '渠道退款单号仅作对账记录，可留空稍后回填。',
  'base.adminOrderRefund.tradeNoRequired': '请填写渠道退款单号',
  'base.adminOrderRefund.tradeNoSuccess': '退款单号已回填',
  'base.adminOrderRefund.saveTradeNo': '回填单号',
  'base.adminOrderRefund.submit': '确认退款',
  'base.adminOrderRefund.success': '已记录退款，请到渠道后台完成退款',
  'base.adminOrderRefund.amountInvalid': '退款金额无效：需大于 0 且不超过可退金额',
  'base.adminOrderRefund.failed': '退款操作失败',

  'base.adminUserCredit.title': '调整点数',
  'base.adminUserCredit.userLabel': '用户名',
  'base.adminUserCredit.creditLabel': '当前点数',
  'base.adminUserCredit.direction': '调整方式',
  'base.adminUserCredit.add': '增加',
  'base.adminUserCredit.sub': '减少',
  'base.adminUserCredit.amount': '数量',
  'base.adminUserCredit.remark': '备注',
  'base.adminUserCredit.remarkPlaceholder': '选填，如：活动赠送',
  'base.adminUserCredit.amountRequired': '请输入大于 0 的数量',
  'base.adminUserCredit.saveSuccess': '调整成功',
  'base.adminUserCredit.saveFailed': '调整失败',

  'base.adminSetting.title': '功能设置',
  'base.adminSetting.creditLabel': '开启点数',
  'base.adminSetting.creditDesc':
    '开启后，点数套餐、点数购买记录、用户点数、充值等点数相关菜单与界面才会显示。',
  'base.adminSetting.saved': '已保存',
  'base.adminSetting.saveFailed': '保存失败',

  'base.adminNotify.title': '运营通知',
  'base.adminNotify.emailsTitle': '通知邮箱',
  'base.adminNotify.emailsDesc': '发生通知事件时，系统会向这些邮箱发送提醒邮件。',
  'base.adminNotify.emailsPlaceholder': 'ops@example.com, admin@example.com',
  'base.adminNotify.emailsHint': '多个邮箱使用逗号分隔；需先在「设置 - 邮件设置」中完成 SMTP 配置。',
  'base.adminNotify.eventsTitle': '通知事件',
  'base.adminNotify.eventsDesc': '开启后，对应业务事件发生时会发送通知邮件。',
  'base.adminNotify.creditRecharge': '用户充值',
  'base.adminNotify.creditRechargeDesc': '用户完成积分/点数充值并到账时通知。',
  'base.adminNotify.saved': '已保存',
  'base.adminNotify.saveFailed': '保存失败',

  // 渠道分析（注册来源归因）
  'base.adminAttr.title': '渠道分析',
  'base.adminAttr.modeFirst': '首触',
  'base.adminAttr.modeLast': '末触',
  'base.adminAttr.dateRange': '注册日期',
  'base.adminAttr.summaryTotal': '注册用户',
  'base.adminAttr.summaryAttributed': '已归因',
  'base.adminAttr.summaryUnknown': '未归因',
  'base.adminAttr.summaryUnknownRate': '未归因占比',
  'base.adminAttr.summaryVisits': '访客数',
  'base.adminAttr.channelTitle': '渠道效果',
  'base.adminAttr.colChannel': '渠道',
  'base.adminAttr.colVisits': '访客',
  'base.adminAttr.colRegisters': '注册',
  'base.adminAttr.colRate': '注册率',
  'base.adminAttr.colShare': '注册占比',
  'base.adminAttr.dimensionTitle': '来源明细',
  'base.adminAttr.tabSource': '来源',
  'base.adminAttr.tabCampaign': '活动',
  'base.adminAttr.tabLanding': '落地页',
  'base.adminAttr.colValue': '名称',
  'base.adminAttr.trendTitle': '注册趋势',
  'base.adminAttr.trendSeries': '注册用户',
  'base.adminAttr.trendEmpty': '暂无注册数据',
  'base.adminAttr.detailTitle': '注册归属明细',
  'base.adminAttr.colUserId': '用户 ID',
  'base.adminAttr.colUsername': '用户名',
  'base.adminAttr.colSource': '来源',
  'base.adminAttr.colMedium': '媒介',
  'base.adminAttr.colCampaign': '活动',
  'base.adminAttr.colLanding': '落地页',
  'base.adminAttr.colReferrer': '引荐域名',
  'base.adminAttr.colRegisterDate': '注册日期',
  'base.adminAttr.colRegisterAt': '注册时间',
  'base.adminAttr.colAction': '操作',
  'base.adminAttr.viewDetail': '查看',
  'base.adminAttr.detailModalTitle': '归属详情',
  'base.adminAttr.detailFirst': '首触',
  'base.adminAttr.detailLast': '末触',
  'base.adminAttr.detailDevice': '设备 ID',
  'base.adminAttr.detailQuery': '落地参数',
  'base.adminAttr.detailInvite': '邀请人',
  'base.adminAttr.detailEmpty': '暂无归属记录',
  'base.adminAttr.searchPlaceholder': '搜索用户名',
  'base.adminAttr.channelCodeTitle': '渠道码',
  'base.adminAttr.channelCodeHint': '推广链接追加 ch=渠道码后，注册用户自动归入对应渠道大类。',
  'base.adminAttr.colCode': '渠道码',
  'base.adminAttr.colName': '名称',
  'base.adminAttr.colChannelType': '渠道大类',
  'base.adminAttr.colRemark': '备注',
  'base.adminAttr.colEnabled': '状态',
  'base.adminAttr.colSort': '排序',
  'base.adminAttr.enabled': '启用',
  'base.adminAttr.disabled': '停用',
  'base.adminAttr.emptyChannels': '暂无渠道码',
  'base.adminAttr.codePlaceholder': '如 douyin_ads',
  'base.adminAttr.namePlaceholder': '如 抖音信息流',
  'base.adminAttr.codeRequired': '请输入渠道码',
  'base.adminAttr.nameRequired': '请输入名称',
  'base.adminAttr.channelRequired': '请选择渠道大类',
  'base.adminAttr.saveSuccess': '保存成功',
  'base.adminAttr.saveFailed': '保存失败',
  'base.adminAttr.deleteSuccess': '删除成功',
  'base.adminAttr.deleteFailed': '删除失败',
  'base.adminAttr.deleteTitle': '删除渠道码',
  'base.adminAttr.deleteConfirm': '确定删除该渠道码吗？删除后已产生的归属数据不受影响。',
  'base.adminAttr.modalAdd': '新增渠道码',
  'base.adminAttr.modalEdit': '修改渠道码',
}
